<template>
  <div class="page-block">
    <div class="page-block">
      <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">推奨環境</h3>
      </div>
      <div class="page-block__inner">
        <div class="privacy-area">
          <p>当サイトをより安全にご利用いただくために、各ブラウザソフトとも最新版のバージョンでご覧いただくことをお勧めします。</p>
          <h4>Windows</h4>
          <p>ブラウザソフト：Google Chrome最新版、Firefox最新版</p>
          <h4>Macintosh</h4>
          <p>ブラウザソフト：Safari最新版、Google Chrome最新版、Firefox最新版</p>
          <h4>スマートフォン(Android)</h4>
          <p>Android 11.X.X Android 10.X.X <br>ブラウザソフト :Google Chrome最新版</p>
          <h4>スマートフォン(iPhone)</h4>
          <p>iOS 14.X.X iOS 13.X.X <br>ブラウザソフト :Safari最新版</p>
          <h4>モニタ解像度</h4>
          <p>1024×768ピクセル以上</p>
          <h4>ブラウザソフトのキャッシュ機能について（古い情報が表示される場合）</h4>
          <p>
            当サイトを開いたときに古い内容が表示されたり 、画像が変わらない、レイアウトが崩れるなどの現象が起きた場合、パソコンのインターネット一時ファイル
            （キャッシュ）フォルダに残っている古いファイルが表示されている場合があります。同フォルダの内容を削除すると、新しいページが表示されます。
            このような場合は、以下の手順でキャッシュを削除してください。
          </p>
          <h4>Windows</h4>
          <p>
            Google Chrome<br>画面右上のその他アイコンをクリック→「その他のツール」→「閲覧履歴を消去」をクリック→上部で期間を選択。すべて削除するには、
            「全期間」を選択→「Cookie と他のサイトデータ」と「キャッシュされた画像とファイル」の横にあるチェックボックスをオン→「データを消去」をクリック
            <br><br>FireFox<br>メニュー「ツール」→「最近の履歴を消去」→消去する項目の「キャッシュ」をチェック→「今すぐ消去」をクリック
          </p>
          <h4>Macintosh</h4>
          <p>
            Safari<br>メニュー「Safari」→「キャッシュを空にする」をクリック<br><br>Google Chrome
            <br>画面右上のその他アイコンをクリック→「その他のツール」→「閲覧履歴を消去」をクリック→上部で期間を選択。
            すべて削除するには、「全期間」を選択→「Cookie と他のサイトデータ」と
            「キャッシュされた画像とファイル」の横にあるチェックボックスをオン→「データを消去」をクリック
            <br><br>FireFox<br>メニュー「ツール」→「最近の履歴を消去」→消去する項目の「キャッシュ」をチェック→「今すぐ消去」をクリック
          </p>
          <h4>CSSについて</h4>
          <p>
            当サイトでは、ほぼ全てのページでCSS（カスケーディングスタイルシート）によるhtmlコーディングを採用しております。
            CSSに対応していないブラウザや、CSSの適用をオフにしている場合、表示が異なる場合があります。
          </p>
          <h4>Javascriptについて</h4>
          <p>
            当サイトは各ページにJavaScriptを使用しております。ブラウザの機能を無効にされている場合、機能、表示が正しく動作されないことがあります。
            JavaScriptを有効にしてご覧ください。また、Internet Explorerをご利用の場合は、セキュリティレベルを「中」に設定してください。
            詳しくは、それぞれのブラウザソフトのヘルプをご参照ください。
          </p>
          <h4>cookie（クッキー）に関して</h4>
          <p>
            「cookie情報」とは、cookieという業界標準の技術を利用し、記録管理を目的として、webサイトがお客様のコンピュータのハードディスクに転送する情報のことです。
            cookieを使用することにより、お客様が頻繁に利用されるサービスについて、操作を簡素化できます。
            多くのブラウザは、cookieを受け入れるように最初から設定されていますがユーザー側でcookieを拒否するように設定することもできます。
            しかしその場合、Webサイトのサービスを十分に活用できなくなる可能性があります。
          </p>
          <h4>セキュリティについて</h4>
          <p>
            お客様の登録情報は、お客様のプライバシー保護およびセキュリティのため、パスワードで保護されています。
            当サイトでは、必要がある場合、データ伝送を保護するために、業界標準のSSL暗号を使用します。
          </p>
          <div class="c-btn-wrap">
            <router-link
              :to="{ name :'index' }"
              class="c-btn c-btn--back">
              トップへ戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left">
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Enviroment',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style scoped>

</style>
